import { Page } from 'pages/layout'
import { Tabs } from '@workwhile/ui'
import { useNavigate, useParams } from 'react-router-dom'
import { OperationsMain } from './Operations/OperationsMain'
import { CostMain } from './Cost/CostMain'
import { PerformanceMain } from './Performance/PerformanceMain'

const tabs = [
  {
    value: 'operations',
    label: 'Operations',
  },
  {
    value: 'cost',
    label: 'Cost',
  },
  {
    value: 'performance',
    label: 'Performance',
  },
]

export function PulseMain() {
  const params = useParams<{ tab: string }>()
  const navigate = useNavigate()

  return (
    <Page title={'Pulse'}>
      <Tabs
        value={params.tab ?? 'operations'}
        onValueChange={(value) => {
          const queryString = window.location.search
          navigate(`/pulse/${value}${queryString}`)
        }}
        tabs={tabs}
      >
        <Tabs.Content value={'operations'}>
          <OperationsMain />
        </Tabs.Content>
        <Tabs.Content value={'cost'}>
          <CostMain />
        </Tabs.Content>
        <Tabs.Content value={'performance'}>
          <PerformanceMain />
        </Tabs.Content>
      </Tabs>
    </Page>
  )
}
